import { Widget } from "@foretagsplatsen/widgetjs";

const nextId = (() => {
	let id = 0;
	return () => `ForecastFiscalYearCard-${id++}`;
})();

/**
 * Card displaying crucial information about the predicted fiscal year.
 *
 * @param {boolean} [oneLiner] - When true, render in one-liner mode
 * @param {RenderingStrategy} [renderingStrategy] - RenderingStrategy to render the ForecastFiscalYearCard, which depends
 * on the report. For example, if the current report is the Profit and Loss report, one should the
 * IncomeStatementForecastFiscalYearCardRenderingStrategy.
 */
export default class ForecastFiscalYearCard extends Widget {
	constructor({ renderingStrategy, oneLiner = false } = {}) {
		super(...arguments);
		this._renderingStrategy = renderingStrategy;
		this._oneLiner = oneLiner;
		this._id = nextId();
	}

	setValues() {
		this._renderingStrategy.setValues(...arguments);

		this.update();
	}

	setOneLinerMode(value) {
		this._oneLiner = value;
		this.update();
	}

	renderContentOn(html) {
		if (this._oneLiner) {
			this._renderingStrategy.renderContentAsOneLinerOn(html);
			return;
		}

		this._renderingStrategy.renderContentAsBigCardOn(html);
	}

	_renderRootOn(html) {
		return html.div().id(this._id);
	}
}
